import React, { useCallback, useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Typography } from 'antd'

import { LightThemeProvider } from '@qflow/theme'

import { OnlyOneItemFilter, RemovedFilter } from 'portal/components/Filters'
import { HorizontalDivider } from 'portal/components/Navigation/Main/Toolbar/Divider'
import { RecordsExport } from 'portal/components/RecordsExport/RecordsExport'
import { Records } from 'portal/components/RecordsModules'
import { ImportButton } from 'portal/components/RecordsModules/common'
import { TableSettingsButton } from 'portal/components/RecordsTable/TableSettingsButton'
import { Sidebar } from 'portal/components/Sidebar'

import { Flex, SideBar, Spacer, Spinner } from 'portal/lib/primitives'
import { PageContainer } from 'portal/pages/PageContainer'
import { selectGlobalDate } from 'portal/store/global/selectors'
import { compose } from 'portal/utils/compose'
import { withMixpanel } from 'portal/utils/mixpanel'

const { Title } = Typography
const EV_RECORDS_OPEN = 'frontend_records_open'
const EV_RECORDS_GENERATE_REPORT = 'frontend_records_generate_report'

const Waste = props => {
  const [filters, setFilters] = useState({})
  const [showRemovedRecords, setShowRemovedRecords] = useState(
    localStorage.getItem('removed-filter') === 'true' ? true : false
  )
  const [onlyShowOneItem, setOnlyShowOneItem] = useState(
    localStorage.getItem('only-one-item-filter') === 'true' ? true : false
  )
  const [sortById, setSortById] = useState(false)

  const trackRecordsOpen = useCallback(() => {
    const { track } = props

    track(EV_RECORDS_OPEN, {
      module_type: 'waste',
      record_type: 'waste'
    })
  }, [props])

  const trackDataExported = useCallback(
    (params = {}) => {
      const { track } = props

      track(EV_RECORDS_GENERATE_REPORT, {
        module_type: 'waste',
        record_type: 'waste',
        ...params
      })
    },
    [props]
  )

  useEffect(() => {
    trackRecordsOpen()
  }, [trackRecordsOpen])

  const onFiltersUpdated = f => {
    setFilters(f)
  }

  const onRemovedFilterToggle = newState => {
    setShowRemovedRecords(newState === 'true' ? true : false)
  }

  const onOnlyOneItemToggle = newState => {
    setOnlyShowOneItem(newState === 'true' ? true : false)
  }

  const updateSortById = newState => {
    setSortById(newState)
  }

  const { isLoading, globalDateRange } = props

  return (
    <LightThemeProvider>
      <Sidebar />
      <PageContainer style={{ paddingTop: '1.5rem', paddingBottom: '0.5rem' }}>
        {isLoading && <Spinner />}

        {!isLoading && (
          <>
            <Flex.Row
              amount={0}
              style={{ width: '99%', alignItems: 'baseline' }}
            >
              <Title level={2} id="Heading" style={{ marginBottom: '0' }}>
                Waste Records
              </Title>
              <Flex.By amount={1} />
              <SideBar.GlobalDatePicker />
            </Flex.Row>
            <HorizontalDivider style={{ width: '99%' }} />
            <Flex.Row amount={0} style={{ width: '99%' }}>
              <TableSettingsButton />
              <Spacer.Fine />
              <RemovedFilter onToggle={onRemovedFilterToggle} />
              <Spacer.Fine />
              <OnlyOneItemFilter onToggle={onOnlyOneItemToggle} />
              <Flex.By amount={1} />
              <ImportButton>Import Weights</ImportButton>
              <Spacer.Tiny />
              <RecordsExport
                title={`Waste_Export_${globalDateRange.startDate.format(
                  'YYYY-MM-DD'
                )}_${globalDateRange.endDate.format('YYYY-MM-DD')}.csv`}
                startDate={globalDateRange.startDate}
                endDate={globalDateRange.endDate}
                filters={filters}
                trackDataExported={trackDataExported}
              />
            </Flex.Row>
          </>
        )}

        <Records.Waste
          startDate={globalDateRange.startDate}
          endDate={globalDateRange.endDate}
          onFiltersUpdated={onFiltersUpdated}
          onlyShowOneItem={onlyShowOneItem}
          showRemovedRecords={showRemovedRecords}
          sortById={sortById}
          updateSortById={updateSortById}
        />
      </PageContainer>
    </LightThemeProvider>
  )
}

Waste.propTypes = {
  isLoading: PropTypes.bool,
  areModulesReady: PropTypes.bool,

  ...withMixpanel.withProps
}

const selectGlobalDateFunc = selectGlobalDate()
const mapStateToProps = state => {
  return {
    isLoading: state.projectDetails.isLoading,
    globalDateRange: selectGlobalDateFunc(state)
  }
}

const ComposedWaste = compose(connect(mapStateToProps), withMixpanel)(Waste)

export { ComposedWaste as Waste }
